export interface CaremapprClinicians {
  created_at: string;
  first_name: string;
  last_name: string;
  roles: string[] | null;
  user_id: number;
  clinics: string[];
  user_status: string;
  tenancyId: number;
}
interface Clinic {
  caremapprClinicians: CaremapprClinicians[];
  tenancy_id: number;
  clinic: string;
  clinic_id: string;
  features: any;
  primaryTeams: any[];
  healthProfessionals: any[];
  organisation_unit: string;
}

export const mapCaremapprUser = (
  clinics: Clinic[],
  currentTenancyId: number,
) => {
  const allUser: Record<number, CaremapprClinicians[]> = {};
  clinics
    .filter((clinic) => clinic.tenancy_id === currentTenancyId)
    .forEach((clinic) => {
      const tenancy_id = clinic.tenancy_id;
      if (!Array.isArray(allUser[tenancy_id])) allUser[tenancy_id] = [];
      clinic.caremapprClinicians
        .filter((clinician) => clinician.tenancyId === currentTenancyId)
        .forEach((caremapprClinician) => {
          const index = allUser[tenancy_id].findIndex(
            (user) => user.user_id === caremapprClinician.user_id,
          );
          if (index === -1) {
            caremapprClinician.clinics = [clinic.clinic_id];
            allUser[tenancy_id].push(caremapprClinician);
          } else {
            allUser[tenancy_id][index].clinics.push(clinic.clinic_id);
            allUser[tenancy_id][index].clinics = Array.from(
              new Set(allUser[tenancy_id][index].clinics),
            ); // ensure only unique values are stored

            // merge roles: prefer non-null; if both present, union
            const existingRoles = allUser[tenancy_id][index].roles;
            const incomingRoles = caremapprClinician.roles;
            if (existingRoles == null && incomingRoles != null) {
              allUser[tenancy_id][index].roles = incomingRoles;
            } else if (existingRoles != null && incomingRoles != null) {
              allUser[tenancy_id][index].roles = Array.from(
                new Set([...existingRoles, ...incomingRoles]),
              );
            }
          }
        });
    });

  return allUser;
};
